let observer;

function initLoadMoreObserver() {
  if (observer) {
    observer.disconnect();
  }

  const loadMoreContainer = document.getElementById('load-more-container');

  if (loadMoreContainer) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const loadMoreButton = document.getElementById('load-more-button');
          if (loadMoreButton && !loadMoreButton.disabled) {
            loadMoreButton.click();
          }
        }
      });
    }, { threshold: 1.0 });

    observer.observe(loadMoreContainer);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initLoadMoreObserver();

  document.body.addEventListener('click', (e) => {
    if (e.target.id === 'load-more-button') {
      e.preventDefault();
      const button = e.target;
      const url = button.href;

      button.textContent = 'Loading...';
      button.disabled = true;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const newProductList = html.querySelector('.product-list');
          if (newProductList) {
            const newProductCards = newProductList.querySelectorAll('.product-card');
            newProductCards.forEach(card => {
              card.style.opacity = '1';
              card.style.transform = 'translateY(0px)';
            });

            const productGrid = document.querySelector('.product-list');
            productGrid.insertAdjacentHTML('beforeend', newProductList.innerHTML);
          }

          const newButtonContainer = html.querySelector('#load-more-container');
          const currentButtonContainer = document.getElementById('load-more-container');

          if (newButtonContainer && newButtonContainer.innerHTML.trim() !== '') {
            currentButtonContainer.innerHTML = newButtonContainer.innerHTML;
            initLoadMoreObserver(); // Re-initialize observer for the new button
          } else {
            currentButtonContainer.remove();
            if (observer) {
              observer.disconnect();
            }
          }
        })
        .catch(error => {
          console.error('Error loading more products:', error);
          button.textContent = 'Load More';
          button.disabled = false;
        });
    }
  });

  // Listen for custom event that signals facet update
  document.addEventListener('facet:updated', () => {
    initLoadMoreObserver();
  });
});
